import type { PropsWithChildren } from 'react'
import { useEffect, useMemo, useState } from 'react'
import { createIntl, createIntlCache, RawIntlProvider } from 'react-intl'
import {
  loadLocaleMessages,
  type LocaleMessages,
} from 'i18n/I18nContext'
import {
  DEFAULT_LOCALE,
  getLocaleDirection,
  getLocaleLanguageCode,
  getLocaleWithWesternDigits,
} from 'i18n/util/locale'

const intlCache = createIntlCache()

export default function SpoofTargetLanguageProvider({
  locale,
  children,
}: PropsWithChildren<{ locale: string }>) {
  const [messages, setMessages] = useState<LocaleMessages>({})

  useEffect(() => {
    let active = true
    loadLocaleMessages(locale).then((loadedMessages) => {
      if (active) setMessages(loadedMessages)
    })

    return () => {
      active = false
    }
  }, [locale])

  const intl = useMemo(() => createIntl({
    locale: getLocaleWithWesternDigits(locale),
    defaultLocale: DEFAULT_LOCALE,
    messages,
    onError: () => undefined,
  }, intlCache), [locale, messages])

  return <RawIntlProvider value={intl}>
    <div dir={getLocaleDirection(locale)} lang={getLocaleLanguageCode(locale)}>
      {children}
    </div>
  </RawIntlProvider>
}
